import { useQuery } from '@apollo/client/react';

import Pill from './Pill';
import {
  GET_CURRENT_PRECO_OFFER,
  GET_PRECO_ELIGIBILITY,
} from 'queries/prechargeoff';
import { hasPrecoOffer, isPrecoOfferInProgress } from 'utilities/helpers';

const PRECO_ELIGIBLE_BUCKETS = [
  'PAST_DUE_121_150_DAYS',
  'PAST_DUE_151_180_DAYS',
];

const PrecoOfferPill = ({ account }) => {
  const accountId = account?.id;
  const accountStatuses = account?.statuses || {};
  const mayHavePrecoOffer =
    accountStatuses.isPastDue || accountStatuses.isChargedOff;
  const isPrecoEligibleBucket =
    PRECO_ELIGIBLE_BUCKETS.includes(accountStatuses.pastDueStatus) &&
    !accountStatuses.isChargedOff;

  const { data: currentOfferData } = useQuery(GET_CURRENT_PRECO_OFFER, {
    variables: { accountId },
    skip: !accountId || !mayHavePrecoOffer,
    fetchPolicy: 'cache-and-network',
  });

  const precoOffer = currentOfferData?.prechargeoffSettlementOffer;
  const hasOffer = hasPrecoOffer(precoOffer);
  const showActiveOffer = isPrecoOfferInProgress(precoOffer);

  const { data: eligibilityData, loading: eligibilityLoading } = useQuery(
    GET_PRECO_ELIGIBILITY,
    {
      variables: { accountId },
      skip:
        !accountId || !isPrecoEligibleBucket || !currentOfferData || hasOffer,
      fetchPolicy: 'no-cache',
    },
  );

  if (!currentOfferData) {
    return null;
  }

  if (showActiveOffer) {
    return <Pill color="teal">Active PreCO Offer</Pill>;
  }

  if (hasOffer || !isPrecoEligibleBucket) {
    return null;
  }

  if (eligibilityLoading) {
    return <Pill>Checking offers...</Pill>;
  }

  if (!eligibilityData?.precoEligibility?.eligible) {
    return null;
  }

  return <Pill color="teal">PreCO Offer Available!</Pill>;
};

export default PrecoOfferPill;
